import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Colordrop = ({
  size,
  type,
  theme,
  className,
  dataTestId = "colordrop-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M5.529.862c.26-.26.682-.26.942 0l6 6c.26.26.26.682 0 .943l-3.723 3.724a2 2 0 0 1-2.829 0L3.138 8.748a2 2 0 0 1 0-2.829L6.39 2.667l-.861-.862a.667.667 0 0 1 0-.943ZM7.333 3.61 4.081 6.862a.667.667 0 0 0 0 .943L4.276 8h6.114l.667-.667L7.333 3.61ZM5.61 9.333l1.253 1.253c.26.26.682.26.943 0l1.252-1.253H5.61Z"
    />
    <path d="M1.333 14c0-.368.299-.667.667-.667h12a.667.667 0 0 1 0 1.334H2A.667.667 0 0 1 1.333 14ZM12.333 12a1 1 0 0 0 1-1c0-.36-.423-1.24-.72-1.81a.314.314 0 0 0-.56 0c-.296.57-.72 1.45-.72 1.81a1 1 0 0 0 1 1Z" />
  </SVGIcon>
);
